// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__fWCsk","consentsList":"PatientConsents_consentsList__37YWg","consentsListEmpty":"PatientConsents_consentsListEmpty__2Lkkp"};